import { createAgent } from 'Lib/portalAgent';

import store from './store';

const agent = createAgent(null, store);

export const request = agent.request;
export default agent;
